import { Checkbox, ColorPicker, DatePicker, Form, Input, InputNumber, Radio, Select, Slider, Switch, TimePicker } from "antd";
import { useAppSelector } from "../hooks";
import { selectConsts } from "../../features/home/homeSlice";

export default function DynamicField(props: any) {
    let consts = useAppSelector(selectConsts);
    const {name, key, type, inputType, options=[], attributes} = props.field;

    let input = <Input/>
    if (inputType == 'checkbox') {
        input = <Checkbox/>
    }
    if (inputType == 'checkboxgroup') {
        input = <Checkbox.Group options={options}/>
    }
    if (inputType == 'colorpicker') {
        input = <ColorPicker/>
    }
    if (inputType == 'datepicker') {
        input = <DatePicker/>;
    }
    if (inputType == 'input') {
        input = <Input/>
    }
    if (inputType == 'inputnumber') {
        input = <InputNumber/>
    }
    if (inputType == 'radio') {
        input = <Radio.Group options={options}/>
    }
    if (inputType == 'select') {
        input = <Select options={options}/>
    }
    if (inputType == 'slider') {
        input = <Slider/>
    }
    if (inputType == 'switch') {
        input = <Switch/>
    }
    if (inputType == 'timepicker') {
        input = <TimePicker/>
    }
    return (<Form.Item
        name={key}
        label={name}
        help={consts && consts.DataVarHelperText ? consts.DataVarHelperText[type] : ''}>
        {input}
    </Form.Item>)
}